import Image from 'next/image';

interface StickerCardProps {
	icon: { src: string; alt: string };
	title: string;
	text: string;
}

const StickerCard = ({ icon, title, text }: StickerCardProps) => {
	const { src, alt } = icon;
	return (
		<article className="w-[75vw] sm:w-60 h-44 bg-blue-light p-3 md:p-4 rounded">
			<div className="flex gap-2 items-center font-bold pb-2 mb-2 border-b-1 border-b-blue-dark h-[51px]">
				<Image src={src} alt={alt} width={32} height={32} />
				<h3>{title}</h3>
			</div>
			<p>{text}</p>
		</article>
	);
};
export default StickerCard;
